import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  siteLanguageListPath,
  SiteLanguageListUrlQueryParams,
  siteLanguagePath
} from "./urls";
import SiteLanguageDetailsComponent from "./views/SiteLanguageDetails";
import SiteLanguageListComponent from "./views/SiteLanguageList";

const SiteLanguageList: React.FC<RouteComponentProps<any>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: SiteLanguageListUrlQueryParams = qs;
  return <SiteLanguageListComponent params={params} />;
};

const SiteLanguageDetails: React.FC<RouteComponentProps<any>> = ({ match }) => {
  const qs = parseQs(location.search.substr(1));
  const params: SiteLanguageListUrlQueryParams = qs;

  return (
    <SiteLanguageDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.siteLanguages)} />
      <Switch>
        <Route exact path={siteLanguageListPath} component={SiteLanguageList} />
        <Route path={siteLanguagePath(":id")} component={SiteLanguageDetails} />
      </Switch>
    </>
  );
};

export default Component;
